import {useEffect, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {searchFormActions, searchFormSlice} from "../slices/search_form_slice";

export const useSearchForm = () => {
    const dispatch = useDispatch();
    const isLocationSearchOpen = useSelector((state: IRPStore) => state.search[searchFormSlice.name].isLocationSearchOpen);
    const locationSearchStatusWatchers = useRef<{cb: (status: boolean) => void; waitFor: boolean}[]>([]);

    const openLocationSearch = () => {
        dispatch(searchFormActions.openLocationSearch());
    };

    const closeLocationSearch = () => {
        dispatch(searchFormActions.closeLocationSearch());
    };

    const setLocationSearchOpenStatus = (isOpen: boolean) => {
        if (isOpen) {
            openLocationSearch();
        } else {
            closeLocationSearch();
        }
    };

    const toggleLocationSearch = () => {
        setLocationSearchOpenStatus(!isLocationSearchOpen);
    };

    useEffect(() => {
        locationSearchStatusWatchers.current = locationSearchStatusWatchers.current.reduce(
            (remainingWatchers, currentWatcher) => {
                if (currentWatcher.waitFor === isLocationSearchOpen) {
                    currentWatcher.cb(isLocationSearchOpen);
                } else {
                    remainingWatchers.push(currentWatcher);
                }

                return remainingWatchers;
            },
            [] as {cb: (status: boolean) => void; waitFor: boolean}[]
        );
    }, [isLocationSearchOpen]);

    return {
        isLocationSearchOpen,
        openLocationSearch,
        toggleLocationSearch,
        setLocationSearchOpenStatus,
        addLocationSearchStatusWatcher: (watcher: (status: boolean) => void, waitForStatus: boolean) => {
            locationSearchStatusWatchers.current.push({cb: watcher, waitFor: waitForStatus});
        }
    };
};
import {useEffect, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {searchFormActions, searchFormSlice} from "../slices/search_form_slice";

export const useSearchForm = () => {
    const dispatch = useDispatch();
    const isLocationSearchOpen = useSelector((state: IRPStore) => state.search[searchFormSlice.name].isLocationSearchOpen);
    const locationSearchStatusWatchers = useRef<{cb: (status: boolean) => void; waitFor: boolean}[]>([]);

    const openLocationSearch = () => {
        dispatch(searchFormActions.openLocationSearch());
    };

    const closeLocationSearch = () => {
        dispatch(searchFormActions.closeLocationSearch());
    };

    const setLocationSearchOpenStatus = (isOpen: boolean) => {
        if (isOpen) {
            openLocationSearch();
        } else {
            closeLocationSearch();
        }
    };

    const toggleLocationSearch = () => {
        setLocationSearchOpenStatus(!isLocationSearchOpen);
    };

    useEffect(() => {
        locationSearchStatusWatchers.current = locationSearchStatusWatchers.current.reduce(
            (remainingWatchers, currentWatcher) => {
                if (currentWatcher.waitFor === isLocationSearchOpen) {
                    currentWatcher.cb(isLocationSearchOpen);
                } else {
                    remainingWatchers.push(currentWatcher);
                }

                return remainingWatchers;
            },
            [] as {cb: (status: boolean) => void; waitFor: boolean}[]
        );
    }, [isLocationSearchOpen]);

    return {
        isLocationSearchOpen,
        openLocationSearch,
        toggleLocationSearch,
        setLocationSearchOpenStatus,
        addLocationSearchStatusWatcher: (watcher: (status: boolean) => void, waitForStatus: boolean) => {
            locationSearchStatusWatchers.current.push({cb: watcher, waitFor: waitForStatus});
        }
    };
};
